import angular from 'angular';

module.exports = angular.module('admin.models.inspection_repair_item', [
])
.factory('InspectionRepairItem', function(odResource) {
  return odResource('/admin/inspection_repair_items/:id/:path', {
    id: '@id'
  }, {
    unaccepted: {
      method: 'GET',
      isArray: true,
      params: { path: 'unaccepted' }
    },
    save: {
      method: 'POST',
      toast: {
        success: 'Inspection repair item created',
        error: 'Failed to create inspection repair item'
      }
    },
    deny: {
      method: 'PATCH',
      params: { path: 'deny' },
      toast: {
        success: 'Inspection repair item denied',
        error: 'Failed to deny inspection repair item'
      }
    },
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/admin/models/inspection_repair_item.js
 **/